import { FlexColumn, FlexRow, LabeledData, StyledButton, useMoment } from '@gorila-shared-ui/components';
import { LabelSmall } from 'baseui/typography';
import { useMemo } from 'react';
import { ONLY_DATE_FORMAT } from '../../../constants/app';
import { useFilesDisplay } from '../../../hooks/useFilesDisplay';
import { useStyles } from '../../../hooks/useStyles';
import { FleetAssetDocumentData } from '../../../types/fleet';
import FileThumbnailPreview from '../../shared/FileThumbnailPreview';
import { useFleetAssetDocuments } from '../hooks/useFleetAssetDocuments';

type Props = Readonly<{
  documentData: FleetAssetDocumentData;
  onClose: () => void;
  onEdit: () => void;
}>;

function FleetAssetDocumentResume({ documentData, onClose, onEdit }: Props) {
  const { css, theme } = useStyles();
  const { formatDateFromTs } = useMoment();
  const { getDocumentColor, getDocumentStatus } = useFleetAssetDocuments();
  const filesKeys = useMemo(() => {
    return [documentData.document];
  }, [documentData.document]);
  const { files } = useFilesDisplay(filesKeys);
  const file = files?.[0];

  return (
    <FlexColumn
      classNames={css({
        justifyContent: 'space-between',
        overflow: 'hidden',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'end',
      })}
    >
      <FlexColumn
        classNames={css({
          overflow: 'auto',
          width: '100%',
          height: '100%',
          flexDirection: 'column',
        })}
        gap={theme.sizing.scale300}
      >
        {file && (
          <FileThumbnailPreview
            display={file}
            imageStyle={{ height: 'auto', objectFit: 'contain' }}
            fileStyle={{ height: '100px' }}
          />
        )}
        <LabeledData
          label="Comentarios:"
          content={documentData.comments || '-'}
          inline={false}
          labelWidth="150px"
        />
        <LabeledData
          label="Fecha de vencimiento:"
          content={`${formatDateFromTs(documentData.expirationDate, ONLY_DATE_FORMAT)}`}
          labelWidth="150px"
        />
        <LabeledData
          label="Estatus:"
          content={
            <LabelSmall
              margin={0}
              color={getDocumentColor(documentData)}
            >
              {getDocumentStatus(documentData.status)}
            </LabelSmall>
          }
          labelWidth="150px"
        />
      </FlexColumn>
      <FlexRow classNames={`${css({ alignItems: 'center', justifyContent: 'flex-end' })}`}>
        <FlexRow gap={theme.sizing.scale300}>
          <StyledButton
            kind="tertiary"
            onClick={onClose}
          >
            Cerrar
          </StyledButton>
          <StyledButton onClick={onEdit}>Editar</StyledButton>
        </FlexRow>
      </FlexRow>
    </FlexColumn>
  );
}

export default FleetAssetDocumentResume;
